import "./_badge.scss";

import classNames from "classnames";

import {TypographyProps} from "../typography/Typography";
import {BadgeType} from "./Badge.types";

export type BadgeProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "className"> & {
  children: React.ReactNode;
  customClassName?: string;
  typography?: TypographyProps<"span">["variant"];
  type?: BadgeType;
};

function Badge({
  children,
  customClassName,
  typography = "tiny",
  type = "default",
  ...otherProps
}: BadgeProps) {
  return (
    <span
      className={classNames(
        "badge",
        `badge--${type}`,
        "is-centered",
        `typography--${typography}`,
        customClassName
      )}
      {...otherProps}>
      {children}
    </span>
  );
}

export default Badge;
